<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-10 18:20:34
 * @LastEditTime: 2022-03-22 15:01:49
-->
<template>
  <div v-if="update">
    <el-steps :active="active"  finish-status="success" process-status="finish">
      <el-step style="flex-basis: 33.3333%" :title="$t('lang.FastAccess.addProject')">
        <span slot="icon">1</span>
      </el-step>
      <el-step style="flex-basis: 33.3333%" :title="$t('lang.FastAccess.addDevice')">
        <span slot="icon">2</span>
      </el-step>
      <el-step style="flex-basis: 33.3333%" :title="$t('lang.FastAccess.addTerminal')">
        <span slot="icon">3</span>
      </el-step>
      <el-step style="flex-basis: 33.3333%" :title="$t('lang.FastAccess.addTemplate')" v-show="hasTemplate">
        <span slot="icon">4</span>
      </el-step>
      <el-step :title="$t('lang.FastAccess.startCollecting')" style="flex-basis: auto!important;flex-shrink: 0;-webkit-box-flex: 0;flex-grow: 0">
        <span v-if="hasTemplate" slot="icon">5</span>
        <span v-else slot="icon">4</span>
      </el-step>
    </el-steps>
    <div style="margin-top: 30px" v-if="active < 4">
      <span class="group-name" v-if="active > 0">
        {{$t('lang.FastAccess.projectName')}}：<el-input class="tips-input" size="mini" v-model="groupName" disabled></el-input>
      </span>
      <span class="group-name" v-if="active > 1">
        {{$t('lang.FastAccess.deviceSn')}}：<el-input class="tips-input" size="mini" v-model="deviceInfo.deviceSn" disabled></el-input>
      </span>
      <span class="group-name" v-if="active > 2">
        {{$t('lang.FastAccess.terminalName')}}：<el-input size="mini" class="tips-input" v-model="terminalInfo.name" disabled ></el-input>
      </span>
    </div>
    
    <div class="settings-detail">
      <add-project ref="addProject" v-show="active === 0" @next="next"></add-project>
      <add-devices ref="addDevices" v-show="active === 1" @next="next" @preStep="preStep" :projectGroupInfo="projectGroupInfo"></add-devices>
    </div>
    <add-terminal ref="addTerminal" v-show="active === 2" :deviceInfo="deviceInfo" @next="next" @preStep="preStep" @setTemplateFlag="setTemplateFlag" @typeChange="typeChange"></add-terminal>
    <add-templete ref="addTemplate" v-show="active === 3" :deviceInfo="deviceInfo" :terminalInfo="terminalInfo" @next="next" @preStep="preStep" :type="type"></add-templete>
    <div class="finally" v-show="active === 4">
      <div class="finally-detail">
        <div style="margin-bottom: 30px; text-align: center">
          <el-button circle type="success" icon="el-icon-check"></el-button>
          <span style="font-size: 20px; font-weight: bolder;margin-left: 10px">{{$t('lang.FastAccess.successTips')}}</span>
        </div>
        <div class="finally-detail_font">
          <p>{{$t('lang.FastAccess.projectTips1')}}：{{groupName}}，{{$t('lang.FastAccess.projectTips2')}}</p>
          <p>{{$t('lang.FastAccess.deviceTips1')}}：{{deviceInfo.deviceSn}}，{{$t('lang.FastAccess.deviceTips2')}}</p>
          <p>{{$t('lang.FastAccess.terminalTips1')}}：{{terminalInfo.name}}，{{$t('lang.FastAccess.terminalTips2')}}</p>
        </div>
        <div style="text-align: center">
          <el-button size="mini" type="primary" @click="continueAdd">{{$t('lang.FastAccess.continueAdd')}}</el-button>
        </div>
      </div>      
    </div>
  </div>
</template>
<script>
import addDevices from './componets/addDevices'
import addTemplete from './componets/addTemplete'
import addTerminal from './componets/addTerminal'
import addProject from './componets/addProject'
import terminalList from '../deviceManagement/terminalList/index'
export default {
  name: 'FastAccess',
  components: {
    addDevices,
    addTemplete,
    addTerminal,
    addProject,
    terminalList
  },
  data() {
    return {
      active: 0,
      hasTemplate: false, // 是否有选择模板这一步，若是新建终端，则显示
      projectGroupInfo: {},
      deviceInfo: {},
      terminalInfo: {},
      templateInfo: {},
      groupName: '',
      type:"0",//模板类别
      update:true, // 用于刷新当前组件
    }
  },
  activated() {
    console.log('缓存了吗');
  },
  watch:{
    projectGroupInfo: {
      immediate: true,
      deep: true,
      handler() {
        if(this.projectGroupInfo) {
          if(this.projectGroupInfo.groupName) {
            this.groupName = this.projectGroupInfo.groupName
          }else{
            if(this.projectGroupInfo.groupTwo && this.projectGroupInfo.groupTwo.groupId) {
              this.groupName = this.projectGroupInfo.groupTwo.groupName
            }else if(this.projectGroupInfo.groupOne && this.projectGroupInfo.groupOne.groupId) {
              this.groupName = this.projectGroupInfo.groupOne.groupName
            }
          }
        }
      }
    }
  },
  methods: {
    // 上、下一步
    next() {
      if(!this.hasTemplate && this.active === 2) { // 若是选择已有的终端无需跳到选择模板步骤，直接从添加终端步骤跳到启用采集
        this.active = 4
      } else{
        this.$refs.addTemplate.clearData()
        this.active = this.active + 1
      }
      if(this.active === 1) { // 进入添加设备步骤，显示项目分组名
        this.projectGroupInfo = this.$refs.addProject.getProjectData()
      }else if(this.active === 2) { // 进入添加终端步骤，显示设备序列号
        this.deviceInfo = this.$refs.addDevices.getSelections()[0]
      }else if(this.active === 3) { // 进入添加模板步骤，显示终端名称
        this.terminalInfo = this.$refs.addTerminal.getData()
      }else if(this.active === 4) { // 进入启动采集，获取模板信息
        this.terminalInfo = this.$refs.addTerminal.getData()
        if(this.hasTemplate) {
          this.templateInfo = this.$refs.addTemplate.getTemplateInfo()
        }
      }
    },
    preStep() {
      if(this.active !==0) {
        if(!this.hasTemplate && this.active === 4) { // 若是选择已有的终端无需跳到选择模板步骤，直接从启用采集跳到添加终端步骤
          this.active = 2
        }else{
          this.$refs.addTemplate.clearData()
          this.active = this.active - 1
        }
      } 
    },
    // continueAdd
    continueAdd() {
      this.update = false
      this.active = 0
      // dom更新后立即执行
      this.$nextTick(() => {
        this.update = true
        this.projectGroupInfo = {}
        this.deviceInfo = {}
        this.terminalInfo = {}
        this.templateInfo = {}
      })
    },
    setTemplateFlag(flag) {
      this.hasTemplate = flag
    },
    typeChange(e){
      this.type = e
    }
  }
}
</script>
<style scoped>
.settings-detail {
  display: flex;
  justify-content: center;
}
.group-name{
  font-size: 16px;
  margin-right: 20px;
}
.tips-input{
  width: 150px;
}
.finally{
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.finally-detail{
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.finally-detail_font{
  font-size: 16px; 
  font-weight: bolder;
  line-height: 40px;
  margin-bottom: 40px;
}
</style>